import { render, staticRenderFns } from "./MessageContentType.vue?vue&type=template&id=0ecc7f83&scoped=true&"
import script from "./MessageContentType.vue?vue&type=script&lang=js&"
export * from "./MessageContentType.vue?vue&type=script&lang=js&"
import style0 from "./MessageContentType.vue?vue&type=style&index=0&id=0ecc7f83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecc7f83",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3744633428/src/vbc-messaging-10-dlc-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ecc7f83')) {
      api.createRecord('0ecc7f83', component.options)
    } else {
      api.reload('0ecc7f83', component.options)
    }
    module.hot.accept("./MessageContentType.vue?vue&type=template&id=0ecc7f83&scoped=true&", function () {
      api.rerender('0ecc7f83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/smsRegistrationComponents/MessageContentType.vue"
export default component.exports